const landingpageData = {
	title: 'Har du styr på grill-hygiejnen?',
	text1: 'Inspireret af Fødevarestyrelsens seneste kampagne, har vi lavet et lille spil, som træner dig i hygiejne ved grillen.',
	text2: 'Når du har gennemført, kan du være med i lodtrækningen om en Morsø Gasgrill.',
};

export {
	landingpageData
};